import { rootApi } from "../../api/rootApi";

export const employeeLevelApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllEmployeeLevel: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/employee/level`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),
    addEmployeeLevel: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/level`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    })
  })
});

export const {
  useFetchAllEmployeeLevelMutation,
  useAddEmployeeLevelMutation
} = employeeLevelApi;
